export default __webpack_public_path__ + "static/media/GABRIELA BONAVITA.699dee4e.jpg";